import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/userRecruil',
    children: [
      {
        path: '',
        name: 'userRecruil',
        meta: {
          title: '长城汽车APP内测招募',
          keepAlive: true,
        },
        component: () => import('@/views/userRecruil/index.vue'),
      },
      {
        path: 'succeView',
        name: 'userRecruilSuccess',
        meta: {
          title: '长城汽车APP内测招募',
        },
        component: () => import('@/views/userRecruil/succeView.vue'),
      },
      {
        path: 'agreement',
        name: 'userRecruilAgreement',
        meta: {
          title: '保密协议',
        },
        component: () => import('@/views/userRecruil/agreement.vue'),
      },
    ],
  },
]

export default routes
